import { theme } from "twin.macro";

const twColor = theme`colors`;

const DEFAULT_COLOR = "blue";
const DEFAULT_LEVEL = 600;

const BRAND_VARIABLES = [
  "--brand-rgb",
  "--brand-hover-rgb",
  "--brand-soft-rgb",
  "--brand-border-rgb",
  "--brand-navy-rgb",
];

// "#2563eb" -> "37 99 235", the channel format the tailwind brand colours read.
export const hexToRgbChannels = (hex) => {
  const value = String(hex || "").replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(value)) {
    return null;
  }
  return [0, 2, 4].map((i) => parseInt(value.slice(i, i + 2), 16)).join(" ");
};

const clampLevel = (level) => Math.min(900, Math.max(50, level));

// The brand tokens follow the tenant's student theme colour. The default blue tenant keeps the
// design-system values baked into tailwind.config.js, so only other tenants get overrides.
export const brandVariablesFor = (themeColor, primaryColorLevel) => {
  const level = Number(primaryColorLevel) || DEFAULT_LEVEL;
  const palette = twColor[themeColor];
  if (!palette || (themeColor === DEFAULT_COLOR && level === DEFAULT_LEVEL)) {
    return null;
  }
  const values = [
    palette[clampLevel(level)],
    palette[clampLevel(level + 100)],
    palette[50],
    palette[200],
    palette[900],
  ].map(hexToRgbChannels);
  if (values.some((v) => v === null)) {
    return null;
  }
  return Object.fromEntries(BRAND_VARIABLES.map((name, i) => [name, values[i]]));
};

export const applyBrandPalette = (themeColor = DEFAULT_COLOR, primaryColorLevel = DEFAULT_LEVEL) => {
  const root = document.documentElement;
  const variables = brandVariablesFor(themeColor, primaryColorLevel);
  BRAND_VARIABLES.forEach((name) => {
    if (variables) {
      root.style.setProperty(name, variables[name]);
    } else {
      root.style.removeProperty(name);
    }
  });
};
